import {
  BUTTON_BACK_TO_ACTIVITIES,
  BUTTON_GOT_IT,
  PARAGRAPH_ACTIVITY_REMOVED_FROM_TEMPLATE,
  REASON_ACTIVITY_REMOVED_FROM_TEMPLATE,
  TITLE_ACTIVITY_REMOVED_FROM_TEMPLATE,
  TITLE_KPI_DISABLED,
  TITLE_KPI_REMOVED_FROM_ACTIVITY,
  TITLE_UNKNOWN_CONFLICT,
} from "../constants/kpiDependencyConflictConstants";
import type { KpiDependencyConflict } from "../types/kpiDependencyConflict";
import { paragraphForKpiConflict } from "./kpiDependencyConflictCopy";

export function kpiConflictTitle(reason: string | undefined): string {
  switch (reason) {
    case REASON_ACTIVITY_REMOVED_FROM_TEMPLATE:
      return TITLE_ACTIVITY_REMOVED_FROM_TEMPLATE;
    case "kpi_removed_from_activity":
      return TITLE_KPI_REMOVED_FROM_ACTIVITY;
    case "kpi_disabled":
      return TITLE_KPI_DISABLED;
    default:
      return TITLE_UNKNOWN_CONFLICT;
  }
}

export function kpiConflictParagraph(conflict: KpiDependencyConflict): string {
  if (conflict.reason === REASON_ACTIVITY_REMOVED_FROM_TEMPLATE) {
    return PARAGRAPH_ACTIVITY_REMOVED_FROM_TEMPLATE;
  }
  return paragraphForKpiConflict(conflict);
}

export function kpiConflictDismissLabel(reason: string | undefined): string {
  return reason === REASON_ACTIVITY_REMOVED_FROM_TEMPLATE
    ? BUTTON_BACK_TO_ACTIVITIES
    : BUTTON_GOT_IT;
}
